<div class="container hide-on-print" [hidden]="_userService.user.role !='superadmin'">
  <div class="row">
    <div class="col">
    </div>
    <div class="float-right">
      <button class="btn btn-secondary-color btn-sm" data-toggle="modal"
        data-target="#AddAdminModal">
        {{ 'ADD_ADMIN_USER' | translate }}</button>
    </div>
  </div>
</div>

<div class="alert alert-warning" role="alert" *ngIf="alert">
  {{ alert | translate}}
</div>

<h4 class="hide-on-print">{{ 'USERS_SEARCH' | translate}}</h4>
<form [formGroup]="searchForm" (ngSubmit)="searchUsers()" class="hide-on-print">
  <div class="row">
    <!-- <div class="form-group col-md-6">
      <label for="name">{{ 'FIRST_NAME' | translate}}</label>
      <input type="text" class="form-control" id="name" formControlName="name">
    </div> -->
    <div class="form-group col-md-6">
      <label for="name">{{ 'LASTNAME' | translate}}</label>
      <input type="text" class="form-control" id="lastname" formControlName="lastname">
    </div>
    <div class="form-group col-md-6">
      <label for="email">{{ 'EMAIL' | translate}}</label>
      <input type="text" class="form-control" id="email" formControlName="email">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" id="all" value="all" name="isLocked" formControlName="isLocked"
          class="custom-control-input" [checked]="true">
        <label class="custom-control-label" for="all">{{ 'ALL' | translate}}</label>
      </div>
      <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" id="locked" value="locked" name="isLocked" formControlName="isLocked"
          class="custom-control-input">
        <label class="custom-control-label" for="locked">{{ 'LOCKED' | translate}}</label>
      </div>
      <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" id="unlocked" value="unlocked" name="isLocked"
          formControlName="isLocked" class="custom-control-input">
        <label class="custom-control-label" for="unlocked">{{ 'UNLOCKED' | translate}}</label>
      </div>

    </div>


  </div>
  <!--   <div class="row">
    <div class="form-group col-md-6">
      <label for="phoneNumber">{{ 'PHONE_NUMBER' | translate}}</label>
      <input type="number" class="form-control" id="phoneNumber" formControlName="phoneNumber">
    </div>
    <div class="form-group col-md-6">
      <label for="docNumber">{{ 'DOCNUMBER' | translate}}</label>
      <input type="text" class="form-control" id="docNumber" formControlName="docNumber">
    </div>
  </div> -->

  <div class="form-group row margin-top">
    <div class="form-group col-md-6">
      <button type="submit" class="btn btn-main-color btn-block">
        {{ 'SEARCH' | translate}}
      </button>
    </div>
    <div class="col-md-6">
      <button type="reset" class="btn btn-secondary-color btn-block" (click)="clearSearchedUsers()">
        {{ 'RESET' | translate}}
      </button>
    </div>
  </div>
</form>

<div class="text-center alert background-main-color" *ngIf="_resourceService.loading">
  <i class="fa fa-refresh fa-spin font-size-20"></i>
  <span> {{ 'LOADING' | translate }}...</span>
</div>

<div *ngIf="searchedUsers?.length && !_resourceService.loading">

  <div class="container hide-on-print">
    <div class="row">
      <div class="col">
        <h4>{{ 'USERS_MEET_CRITERIA' | translate}}</h4>
      </div>
      <div class="float-right">
        <button class="btn btn-secondary-color btn-sm" (click)="print()">{{
          'PRINT' | translate }}</button>
      </div>
    </div>
  </div>


  <div id="container" [@listAnimation]="searchedUsers.length">
    <div *ngFor="let user of searchedUsers; let i = index" [@listAnimation]="state">
      <div class="card sm-12"
        [hidden]="user.role != 'user' && _userService.user.role !='superadmin' && _userService.user.email != user.email">
        <div class="card-header btn-main-color">
          <span *ngIf="user.role == 'user'">{{ user.name | uppercase }}
            {{ user.lastname | uppercase }} </span>
          <span *ngIf="user.role =='consultant'"> {{ user.email}} -
            {{ 'CONSULTANT' | translate | uppercase}}</span>
          <span *ngIf="user.role == 'admin'"> {{ user.email}} -
            {{ 'ADMINISTRATOR' | translate}}</span>
          <span *ngIf="user.role =='superadmin'"> {{ user.email}} -
            {{ 'SUPERADMINISTRATOR' | translate}}</span>
        </div>

        <div class="card-body">

          <div class="row">
            <div class="col-md-6">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ 'NAME' | translate}}:</span>
                </div>
                <input type="text" class="form-control" value="{{user.name}}" disabled>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ 'LASTNAME' | translate}}:</span>
                </div>
                <input type="text" class="form-control" value="{{user.lastname}}" disabled>
              </div>
            </div>
          </div>

          <!-- Si no tiene dependiente -->
          <div class="row" *ngIf="!user.parent">
            <div class="col-md-6">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ 'PHONE_NUMBER' | translate}}:</span>
                </div>
                <input type="text" class="form-control" value="{{user.phoneNumber}}" disabled>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ 'EMAIL' | translate}}:</span>
                </div>
                <input type="text" class="form-control" value="{{user.email}}" disabled>
              </div>
            </div>
          </div>

          <!-- Si tiene dependiente -->
          <div class="card margin-bottom" *ngIf="user.parent">
            <div class="card-header background-secondary-color">
              {{ 'DEPENDENT_ON' | translate}}: {{user.parent.name}} {{user.parent.lastname}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{ 'PHONE_NUMBER' | translate}}:</span>
                    </div>
                    <input type="text" class="form-control" value="{{user.parent.phoneNumber}}"
                      disabled>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{ 'EMAIL' | translate}}:</span>
                    </div>
                    <input type="text" class="form-control" value="{{user.parent.email}}" disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div class="row margin-bottom" *ngIf="user.locked">
            <div class="col-md-6">
              <label for="lockReason">{{ 'LOCK_REASON' | translate}}</label>
              <textarea type="text" id="lockReason" class="form-control" value="{{user.lockReason}}"
                rows="3" disabled></textarea>
            </div>
            <div class="col-md-6">

              <label for="lockDate">
                {{ 'LOCK_DATE' | translate}}
              </label>

              <input class="form-control" id="lockDate" class="form-control"
                value="{{user.lockDate}}" disabled maxlength="5">

            </div>
          </div>
          <div *ngIf="!user.parent">
            <div class="row  hide-on-print">
              <div class="col-md-12">
                <small class="text-muted">{{ 'OPTIONS' | translate}}</small>
              </div>
            </div>
            <div class="row  hide-on-print">
              <div class="col-md-12">
                <button type="button" class="btn background-secondary-color" data-toggle="modal"
                  data-target="#EditedUserModal" (click)="editUser(user)">
                  {{ 'EDIT' | translate}}
                </button>
                <button type="button" class="btn background-secondary-color" *ngIf="!user.locked"
                  data-toggle="modal" data-target="#LockUserModal" (click)="selectUser(user)">
                  {{ 'LOCK' | translate}}
                </button>
                <button type="button" class="btn background-secondary-color" *ngIf="user.locked"
                  (click)="unlockUser(user)">
                  {{ 'UNLOCK' | translate}}
                </button>
                <button type="button" class="btn background-secondary-color" data-toggle="modal"
                  data-target="#ChangePassModal" (click)="selectUser(user)">
                  {{ 'CHANGE_PASSWORD' | translate}}
                </button>
                <button type="button" class="btn btn-danger" data-toggle="modal"
                  data-target="#DeleteUserModal" (click)="selectUser(user)">
                  {{ 'DELETE' | translate}}
                </button>
                <button type="button" class="btn background-secondary-color"
                  *ngIf="user.role == 'admin' && _userService.user.role =='superadmin'"
                  (click)="changeUserRole(user, 'superadmin')">
                  {{ 'CONVERT_TO_SUPERADMINSTRATOR' | translate}}
                </button>
                <button type="button" class="btn background-secondary-color"
                  *ngIf="user.role == 'superadmin' && _userService.user.role =='superadmin'"
                  (click)="changeUserRole(user, 'admin')">
                  {{ 'CONVERT_TO_ADMINSTRATOR' | translate}}
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="user.parent">
            <div class="row  hide-on-print">
              <div class="col-md-12">
                <small class="text-muted">{{ 'OPTIONS' | translate}}</small>
              </div>
            </div>
            <div class="row  hide-on-print">
              <div class="col-md-12">
                <button type="button" class="btn background-secondary-color" data-toggle="modal"
                  data-target="#RemoveDependencyModal" (click)="selectUser(user)">
                  {{ 'REMOVE_DEPENDENCY' | translate}}
                </button>
                <button type="button" class="btn btn-danger" data-toggle="modal"
                  data-target="#DeleteUserModal" (click)="selectUser(user)">
                  {{ 'DELETE' | translate}}
                </button>
              </div>
            </div>
          </div>


        </div>
      </div>
      <br />
      <br />
    </div>
  </div>
</div>



<!-- The delete user Modal -->
<div class="modal fade" id="DeleteUserModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-body">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'ARE_YOU_SURE' | translate}}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <p>
            {{ 'DO_YOU_WANT_DELETE_USER' | translate}}
            {{selectedUser?.name}} {{selectedUser?.lastname}}
          </p>
          <div class="row">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-danger btn-block" (click)="deleteUser()"
                data-dismiss="modal">
                {{ 'YES' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
                {{ 'NO' | translate}}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- The lock user Modal -->
<div class="modal fade" id="LockUserModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-body">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'LOCK_USER' | translate}}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <div class="row">
            <p>
              {{ 'CONFIRM_LOCK_USER' | translate}}
              {{selectedUser?.name}} {{selectedUser?.lastname}}
            </p>
          </div>

          <div class="row margin-bottom">
            <label for="lockReason">{{ 'LOCK_REASON' | translate}}</label>
            <textarea type="text" id="lockReason" class="form-control" name="lockReason"
              [(ngModel)]="lockReason" maxlength="1023" rows="3"></textarea>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-danger btn-block"
                (click)="lockUser(selectedUser)" data-dismiss="modal">
                {{ 'YES' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
                {{ 'NO' | translate}}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- The edit user Modal -->
<div class="modal fade" id="EditedUserModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-body">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'EDIT_USER' | translate}}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="alert alert-warning" role="alert" *ngIf="modalAlert">
          {{ modalAlert | translate}}
        </div>
        <div class="modal-body">
          <div class="alert alert-primary" role="alert">
            {{ 'ONLY_CAN_EDITED_MAIL' | translate}}
          </div>
          <div class="col-md-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ 'NAME' | translate}}:</span>
              </div>
              <input type="text" class="form-control" value="{{selectedUser?.name}}" disabled>
            </div>
          </div>
          <div class="col-md-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ 'LASTNAME' | translate}}:</span>
              </div>
              <input type="text" class="form-control" value="{{selectedUser?.lastname}}" disabled>
            </div>
          </div>

          <div class="col-md-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ 'PHONE_NUMBER' | translate}}:</span>
              </div>
              <input type="text" class="form-control" value="{{selectedUser?.phoneNumber}}"
                disabled>
            </div>
          </div>
          <div class="col-md-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ 'EMAIL' | translate}}:</span>
              </div>
              <input type="text" class="form-control" value="{{selectedUser?.email}}"
                [(ngModel)]="editedMail">
            </div>
          </div>



          <div class="row">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-danger btn-block" (click)="updateUser()">
                {{ 'EDIT' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
                {{ 'CANCEL' | translate}}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- The change pass Modal -->
<div class="modal fade" id="ChangePassModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-body">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'CHANGE_PASSWORD' | translate}}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="alert alert-danger" role="alert" *ngIf="_userService.danger">
          {{ _userService.danger | translate }}
        </div>
        <div class="modal-body">
          <form [formGroup]="formaPass" (ngSubmit)="changeUserPass()">
            <div class="row">

              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">{{ 'NEW_PASSWORD' | translate}}</label>
                <input class="form-control"
                  [ngClass]="{ 'is-invalid': !formaPass.controls['password'].valid && formaPass.controls['password'].value}"
                  type="password" placeholder="{{ 'PASSWORD' | translate}}"
                  formControlName="password">
              </div>

              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">{{ 'RETYPE_NEW_PASSWORD' | translate}}</label>
                <input class="form-control"
                  [ngClass]="{ 'is-invalid': !formaPass.controls['confirmpassword'].valid }"
                  type="password" placeholder="{{ 'CONFIRM_PASSWORD' | translate}}"
                  formControlName="confirmpassword">
                <div class="form-control-feedback invalid-feedback">
                  {{ 'THE_PASSWORDS_ARE_NOT_EQUAL' | translate}}
                </div>
              </div>

            </div>




            <div class="form-group row">
              <div class="form-group col-md-12">
                <button type="submit" class="btn background-main-color btn-block"
                  [disabled]="!formaPass.controls['password'].value ||!formaPass.controls['confirmpassword'].value || !formaPass.valid">
                  {{ 'CHANGE_PASSWORD' | translate}}
                </button>
              </div>
              <div class="col-md-12">
                <button type="reset" class="btn background-secondary-color btn-block">
                  {{ 'RESET' | translate}}
                </button>
              </div>
            </div>

            <div class="alert alert-danger" role="alert"
              [innerHtml]="'PASSWORD_INSTRUCTIONS' | translate">
            </div>

          </form>
        </div>

      </div>
    </div>
  </div>
</div>





<!-- The Add Admin Modal -->
<div class="modal fade" id="AddAdminModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'ADD_ADMIN_USER' | translate}} </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body" *ngIf="_userService?.loading">
        <loading-component>
        </loading-component>
      </div>

      <div class="modal-body" *ngIf="!_userService?.loading">
        <div class="alert alert-danger" role="alert" *ngIf=" _resourceService.alert">
          {{ _resourceService.alert | translate }}
        </div>
        <div class="form-group">
          <label for="email">{{ 'ID' | translate}} *</label>
          <div class="input-group col-12">
            <input type="text" class="form-control" id="id" placeholder="id"
              [(ngModel)]="newAdmin.id">
          </div>
        </div>
        <div class="form-group">
          <label for="email">{{ 'EMAIL' | translate}} *</label>
          <div class="input-group col-12">
            <input type="text" class="form-control" id="email" placeholder="email"
              [(ngModel)]="newAdmin.email">
          </div>
        </div>

        <!--         <div class="form-group">
          <label for="password">{{ 'PASSWORD' | translate}} *</label>
          <div class="input-group col-12">
            <input type="text" class="form-control" id="password" placeholder="Password"
              [(ngModel)]="newAdmin.password">
          </div>
        </div> -->

        <div class="form-group">
          <label for="portalRole">{{ 'ROLE' | translate}} *</label>
          <div class="input-group col-12">
            <select class="form-control" [(ngModel)]="newAdmin.portalRole" name="portalRole"
              placeholder="Select role">
              <option value="admin">Admin</option>
              <option value="superadmin">SuperAdmin</option>
            </select>
          </div>
        </div>

        <div class="col text-center">
          <button type="submit" class="btn btn-main-color" (click)="addAdminUser()">
            {{ 'ADD_ADMIN_USER' | translate}}
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- The Remove dependency Modal -->
<div class="modal fade" id="RemoveDependencyModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-body">
        <div class="alert alert-danger" role="alert" *ngIf=" _resourceService.alert">
          {{ _resourceService.alert | translate }}
        </div>
        <div class="modal-header">
          <h4 class="modal-title">{{ 'REMOVE_DEPENDENCY' | translate}}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="alert alert-warning" role="alert" *ngIf="modalAlert">
          {{ modalAlert | translate}}
        </div>
        <div class="modal-body">
          <div class="alert alert-primary" role="alert">
            {{ 'REMOVE_DEPENDENCY_INFORMATION' | translate}}
          </div>
          <div class="form-group">
            <label for="newUserRemovingDependencyUsername">{{ 'USERNAME_EMAIL' | translate}}
              *</label>
            <div class="input-group col-12">
              <input type="text" class="form-control" id="newUserRemovingDependencyUsername"
                placeholder="{{ 'USERNAME_EMAIL' | translate}}"
                [(ngModel)]="newUserRemovingDependency.email">
            </div>
          </div>

          <div class="form-group">
            <label for="newUserRemovingDependencyPass">{{ 'PASSWORD' | translate}} *</label>
            <div class="input-group col-12">
              <input type="text" class="form-control" id="newUserRemovingDependencyPass"
                placeholder="{{ 'PASSWORD' | translate}}"
                [(ngModel)]="newUserRemovingDependency.password">
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-danger btn-block" (click)="removeDependency()"
                [disabled]="!newUserRemovingDependency.email || !newUserRemovingDependency.password">
                {{ 'REMOVE_DEPENDENCY' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
                {{ 'CANCEL' | translate}}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>